export interface Movie {
  id: string;
  title: string;
  type: "movie" | "series";
  year: number;
  region: string;
  genres: string[];
  rating: number;
  popularity: number;
  cover: string;
  hero: string;
  synopsis: string;
  description: string;
  tags: string[];
  episodes: number;
  director: string;
  cast: string[];
  featured: boolean;
}

export const movies: Movie[] = [
  {
    id: "tokyo-nightwalk",
    title: "东京夜行",
    type: "movie",
    year: 2024,
    region: "东京",
    genres: ["悬疑", "犯罪"],
    rating: 8.7,
    popularity: 9820,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20noir%20movie%20poster%2C%20rainy%20Tokyo%20alley%20at%20night%20with%20neon%20reflections%2C%20silhouette%20of%20a%20detective%20holding%20an%20umbrella%2C%20moody%20dark%20red%20and%20black%20tones%2C%20minimal%20typography%20space%2C%20high%20detail%20editorial%20art&width=400&height=600&seq=mv-cover-01&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20rainy%20Tokyo%20street%20at%20night%2C%20glowing%20neon%20signs%20in%20red%20and%20amber%2C%20wet%20asphalt%20reflections%2C%20lonely%20figure%20walking%20with%20umbrella%2C%20moody%20atmospheric%20film%20still%2C%20dramatic%20lighting%2C%20high%20detail&width=1600&height=900&seq=mv-hero-01&orientation=landscape",
    synopsis: "一名侦探在东京霓虹夜色中追查连环失踪案，逐步揭开被掩埋的真相。",
    description:
      "深夜的东京，霓虹与雨声交织。侦探藤堂接到一桩看似普通的失踪案，却发现受害者之间隐藏着跨越十年的联系。随着调查深入，他不得不在真相与正义之间做出抉择。影片以冷峻的镜头语言，勾勒出一座既繁华又孤独的城市。",
    tags: ["都市", "烧脑", "复仇", "高口碑"],
    episodes: 0,
    director: "佐藤健吾",
    cast: ["高桥凉介", "中村绫", "石田刚"],
    featured: true,
  },
  {
    id: "kyoto-seasons",
    title: "京都四季",
    type: "series",
    year: 2023,
    region: "京都",
    genres: ["剧情", "家庭"],
    rating: 9.1,
    popularity: 8760,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20Japanese%20family%20drama%20poster%2C%20traditional%20Kyoto%20machiya%20house%20with%20autumn%20maple%20leaves%2C%20soft%20golden%20afternoon%20light%2C%20elderly%20woman%20on%20wooden%20engawa%20porch%2C%20gentle%20nostalgic%20mood%2C%20muted%20warm%20tones%2C%20elegant%20composition&width=400&height=600&seq=mv-cover-02&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Serene%20traditional%20Kyoto%20garden%20in%20autumn%2C%20vivid%20red%20maple%20leaves%20over%20wooden%20temple%20veranda%2C%20soft%20golden%20sunlight%2C%20misty%20mountains%20in%20distance%2C%20cinematic%20film%20still%2C%20warm%20harmonious%20tones&width=1600&height=900&seq=mv-hero-02&orientation=landscape",
    synopsis: "一间百年老宅与三代人的故事，在京都的四季流转中缓缓展开。",
    description:
      "在京都的一间百年町屋里，年迈的祖母与从东京归来的孙女共同生活。春夏秋冬，庭院里的枫叶与樱花见证着家族的团聚与别离。剧集以细腻的生活流叙事，讲述关于亲情、传承与和解的温柔故事。",
    tags: ["治愈", "家庭", "生活流", "口碑佳作"],
    episodes: 12,
    director: "小林真由",
    cast: ["吉永千鹤", "松本奈绪", "田边和也"],
    featured: true,
  },
  {
    id: "cafe-in-rain",
    title: "雨中的咖啡馆",
    type: "movie",
    year: 2023,
    region: "东京",
    genres: ["爱情", "剧情"],
    rating: 8.2,
    popularity: 7210,
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20Japanese%20film%20poster%2C%20cozy%20vintage%20coffee%20shop%20window%20on%20a%20rainy%20evening%2C%20two%20cups%20of%20coffee%2C%20warm%20amber%20interior%20light%2C%20blurred%20raindrops%20on%20glass%2C%20soft%20intimate%20atmosphere%2C%20muted%20warm%20color%20grading&width=400&height=600&seq=mv-cover-03&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20Japanese%20coffee%20shop%20interior%20on%20a%20rainy%20day%2C%20wooden%20counter%2C%20steaming%20coffee%20cup%2C%20large%20window%20with%20rain%20streaks%2C%20soft%20amber%20lighting%2C%20nostalgic%20cinematic%20mood%2C%20shallow%20depth%20of%20field&width=1600&height=900&seq=mv-hero-03&orientation=landscape",
    synopsis: "一场大雨，把两个素不相识的人困在东京街角的一间老咖啡馆里。",
    description:
      "暴雨的午后，作家与人像摄影师在同一间老咖啡馆避雨。一杯咖啡的时间，两人分享了各自的故事与遗憾。雨停之后，他们是否还能再见？影片用极简的场景与克制的对白，讲述一段恰到好处的心动。",
    tags: ["纯爱", "慢节奏", "都市", "文艺"],
    episodes: 0,
    director: "山本由纪",
    cast: ["森冈翔", "白石麻衣"],
    featured: false,
  },
  {
    id: "when-sakura-falls",
    title: "樱花散落时",
    type: "series",
    year: 2024,
    region: "大阪",
    genres: ["爱情", "剧情"],
    rating: 8.5,
    popularity: 9340,
    cover:
      "https://readdy.ai/api/search-image?query=Emotional%20Japanese%20romance%20drama%20poster%2C%20two%20young%20people%20standing%20under%20cherry%20blossom%20trees%2C%20petals%20falling%20in%20soft%20pink%20and%20white%2C%20distant%20Osaka%20cityscape%2C%20gentle%20spring%20light%2C%20tender%20melancholic%20tone%2C%20elegant%20cinematic%20composition&width=400&height=600&seq=mv-cover-04&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20spring%20scene%2C%20cherry%20blossom%20trees%20in%20full%20bloom%20along%20a%20path%2C%20soft%20pink%20petals%20drifting%20in%20the%20air%2C%20warm%20sunlight%20with%20lens%20flare%2C%20people%20walking%20in%20distance%2C%20dreamy%20romantic%20film%20still&width=1600&height=900&seq=mv-hero-04&orientation=landscape",
    synopsis: "从大阪到东京，一段跨越五年的爱情，在樱花的开与落之间反复拉扯。",
    description:
      "大学生凉太与真纪在樱花季相遇，却因各自的梦想走向不同城市。五年间，他们错过、重逢、再错过。剧集以时间为轴，记录一段关于选择与成长的爱情长跑，让人想起青春里那个没能说出口的人。",
    tags: ["青春", "虐恋", "成长", "催泪"],
    episodes: 10,
    director: "中岛美咲",
    cast: ["菅田裕介", "桥本爱", "高畑淳"],
    featured: true,
  },
  {
    id: "shinkansen-mystery",
    title: "新干线谜案",
    type: "movie",
    year: 2022,
    region: "东京",
    genres: ["悬疑", "犯罪"],
    rating: 8.0,
    popularity: 6890,
    cover:
      "https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%2C%20Japanese%20bullet%20train%20speeding%20through%20countryside%2C%20silhouette%20of%20mysterious%20passenger%20in%20corridor%2C%20cold%20gray%20and%20deep%20red%20tones%2C%20tension%20and%20motion%20blur%2C%20minimal%20graphic%20design&width=400&height=600&seq=mv-cover-05&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Japanese%20bullet%20train%20interior%20corridor%2C%20tense%20atmosphere%2C%20empty%20seats%20receding%20into%20perspective%2C%20cold%20blue%20gray%20lighting%20with%20red%20emergency%20accents%2C%20mystery%20thriller%20film%20still%2C%20dramatic%20shadows&width=1600&height=900&seq=mv-hero-05&orientation=landscape",
    synopsis: "一列高速行驶的新干线上，一场精心策划的犯罪正在上演。",
    description:
      "开往东京的新干线列车中途突发状况，车厢内的乘客发现他们被卷入一桩密室般的案件。刑警与素人乘客联手推理，随着时间一分一秒流逝，真凶的身份逐渐浮出水面。",
    tags: ["密室", "推理", "犯罪", "高能"],
    episodes: 0,
    director: "井上浩二",
    cast: ["阿部隆", "长泽雅美", "香川照"],
    featured: false,
  },
  {
    id: "midnight-diner",
    title: "深夜食堂物语",
    type: "series",
    year: 2023,
    region: "东京",
    genres: ["剧情", "家庭"],
    rating: 8.9,
    popularity: 8120,
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20Japanese%20food%20drama%20poster%2C%20small%20intimate%20late%20night%20diner%20with%20warm%20lanterns%2C%20steaming%20bowls%20of%20ramen%20on%20counter%2C%20lone%20chef%20silhouette%2C%20warm%20amber%20and%20red%20tones%2C%20nostalgic%20comforting%20mood&width=400&height=600&seq=mv-cover-06&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Warm%20intimate%20Japanese%20midnight%20diner%20interior%2C%20wooden%20counter%2C%20glowing%20paper%20lanterns%2C%20steaming%20dishes%2C%20soft%20amber%20lighting%2C%20few%20seats%2C%20cozy%20nostalgic%20cinematic%20atmosphere&width=1600&height=900&seq=mv-hero-06&orientation=landscape",
    synopsis: "一家只在深夜营业的小店，用一道道家常菜温暖着城市里的每个人。",
    description:
      "深夜十二点，小店准时开门。形形色色的客人带着各自的心事而来，又在热腾腾的饭菜中卸下疲惫。每一集讲述一位客人的故事，食物是引子，人心才是主角。",
    tags: ["美食", "治愈", "单元剧", "烟火气"],
    episodes: 24,
    director: "松冈锭司",
    cast: ["小林薰", "绫濑遥", "多部未华子"],
    featured: true,
  },
  {
    id: "bakumatsu-storm",
    title: "幕末风云",
    type: "series",
    year: 2022,
    region: "京都",
    genres: ["历史", "剧情"],
    rating: 8.4,
    popularity: 6450,
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20Japanese%20historical%20drama%20poster%2C%20samurai%20warrior%20in%20traditional%20armor%20standing%20before%20burning%20castle%2C%20dramatic%20crimson%20sky%2C%20falling%20embers%2C%20solemn%20powerful%20mood%2C%20dark%20red%20and%20gold%20tones%2C%20painterly%20composition&width=400&height=600&seq=mv-cover-07&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Epic%20historical%20Japanese%20scene%2C%20traditional%20castle%20silhouette%20against%20dramatic%20crimson%20sunset%2C%20banners%20and%20samurai%20figures%20in%20distance%2C%20drifting%20smoke%2C%20cinematic%20sweeping%20landscape%2C%20rich%20warm%20tones&width=1600&height=900&seq=mv-hero-07&orientation=landscape",
    synopsis: "幕末乱世，一位年轻武士在时代洪流中寻找自己的道路。",
    description:
      "动荡的幕末时代，京都成为各方势力角力的舞台。出身平凡的武士周平被卷入改变国家命运的漩涡，他必须在忠诚与理想之间做出选择。剧集以恢弘的场景再现那个风云激荡的年代。",
    tags: ["大河剧", "武士", "权谋", "史诗"],
    episodes: 40,
    director: "大友启史",
    cast: ["堺雅人", "新垣结衣", "役所广司"],
    featured: false,
  },
  {
    id: "cat-and-tram",
    title: "猫与电车",
    type: "movie",
    year: 2024,
    region: "北海道",
    genres: ["动画", "奇幻"],
    rating: 8.8,
    popularity: 7590,
    cover:
      "https://readdy.ai/api/search-image?query=Charming%20Japanese%20animated%20film%20poster%2C%20a%20white%20cat%20sitting%20on%20an%20old%20tram%20window%20seat%2C%20snowy%20Hokkaido%20village%20in%20background%2C%20soft%20winter%20light%2C%20whimsical%20gentle%20mood%2C%20pastel%20warm%20cool%20contrast%2C%20beautiful%20hand%20painted%20styled&width=400&height=600&seq=mv-cover-08&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Whimsical%20animated%20scene%20of%20a%20vintage%20tram%20traveling%20through%20snowy%20Hokkaido%20countryside%2C%20soft%20pastel%20winter%20palette%2C%20gentle%20falling%20snow%2C%20warm%20interior%20lights%20glowing%2C%20dreamy%20hand%20painted%20anime%20style&width=1600&height=900&seq=mv-hero-08&orientation=landscape",
    synopsis: "一只会说话的猫，带着小女孩登上了一列驶向云端的电车。",
    description:
      "失去母亲的少女小凛，在冬日的车站遇见了一只会说话的猫。猫邀请她登上一列神秘电车，沿途的每一站都是一段回忆。在旅途中，小凛学会了告别，也重新找回了前行的勇气。",
    tags: ["治愈", "奇幻", "手绘", "全年龄"],
    episodes: 0,
    director: "新海诚辉",
    cast: ["芦田爱菜", "神木隆之介"],
    featured: true,
  },
  {
    id: "star-inheritor",
    title: "星之继承者",
    type: "series",
    year: 2024,
    region: "东京",
    genres: ["科幻", "剧情"],
    rating: 8.3,
    popularity: 7020,
    cover:
      "https://readdy.ai/api/search-image?query=Sci-fi%20Japanese%20drama%20poster%2C%20young%20astronaut%20gazing%20at%20a%20vast%20starfield%2C%20spaceship%20silhouette%2C%20deep%20indigo%20and%20warm%20orange%20nebula%2C%20hopeful%20sci-fi%20atmosphere%2C%20clean%20modern%20graphic%20design&width=400&height=600&seq=mv-cover-09&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%2C%20Earth%20seen%20from%20orbit%20with%20glowing%20cities%2C%20vast%20starfield%20and%20warm%20orange%20nebula%2C%20spaceship%20silhouette%20crossing%20frame%2C%20cinematic%20hopeful%20mood%2C%20high%20detail&width=1600&height=900&seq=mv-hero-09&orientation=landscape",
    synopsis: "地球资源枯竭之际，一群年轻人踏上寻找新家园的星际旅程。",
    description:
      "近未来，地球面临生存危机。年轻的宇航员团队肩负起人类的希望，前往遥远星系寻找适合居住的行星。漫长的航行中，他们面对技术的极限与人性的考验。剧集融合硬核科幻与细腻的情感刻画。",
    tags: ["科幻", "太空", "团队", "热血"],
    episodes: 12,
    director: "庵野秀明介",
    cast: ["山崎贤人", "广濑铃", "松田龙平"],
    featured: false,
  },
  {
    id: "seaside-bookstore",
    title: "海边书店",
    type: "movie",
    year: 2023,
    region: "其他",
    genres: ["爱情", "剧情"],
    rating: 8.1,
    popularity: 6180,
    cover:
      "https://readdy.ai/api/search-image?query=Peaceful%20Japanese%20film%20poster%2C%20small%20seaside%20bookstore%20with%20open%20door%20facing%20the%20ocean%2C%20afternoon%20sunlight%2C%20stacks%20of%20books%2C%20woman%20reading%20by%20window%2C%20soft%20warm%20coastal%20tones%2C%20calm%20nostalgic%20mood&width=400&height=600&seq=mv-cover-10&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Calm%20seaside%20Japanese%20town%2C%20small%20bookstore%20by%20the%20sea%2C%20gentle%20waves%2C%20warm%20late%20afternoon%20sunlight%2C%20soft%20pastel%20sky%2C%20peaceful%20cinematic%20film%20still%2C%20gentle%20nostalgic%20tone&width=1600&height=900&seq=mv-hero-10&orientation=landscape",
    synopsis: "在镰仓的一间海边书店里，两个爱书的人开始了一段缓慢的爱情。",
    description:
      "辞去都市工作的奈绪回到故乡镰仓，接手了祖父留下的海边书店。常来买书的青年作家与她因书结缘，两人在潮起潮落间慢慢靠近。影片温柔地讲述关于重新出发与喜欢一个人的故事。",
    tags: ["文艺", "纯爱", "治愈", "海岸"],
    episodes: 0,
    director: "是枝裕和树",
    cast: ["苍井优", "妻夫木聪"],
    featured: false,
  },
  {
    id: "crime-city-osaka",
    title: "犯罪都市·大阪",
    type: "movie",
    year: 2022,
    region: "大阪",
    genres: ["犯罪", "悬疑"],
    rating: 7.9,
    popularity: 5940,
    cover:
      "https://readdy.ai/api/search-image?query=Gritty%20crime%20thriller%20poster%2C%20night%20view%20of%20Osaka%20Dotonbori%20with%20bright%20signs%2C%20lone%20man%20in%20coat%20walking%20away%2C%20dark%20red%20and%20teal%20contrast%2C%20tense%20urban%20mood%2C%20cinematic%20high%20contrast&width=400&height=600&seq=mv-cover-11&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Neon-lit%20Osaka%20night%20street%2C%20dense%20illuminated%20signs%2C%20wet%20pavement%20reflections%2C%20crowd%20blurred%20in%20motion%2C%20tense%20crime%20thriller%20film%20still%2C%20dramatic%20contrast%20of%20red%20and%20dark%20tones&width=1600&height=900&seq=mv-hero-11&orientation=landscape",
    synopsis: "大阪地下势力暗流涌动，一名刑警决心撕开城市光鲜表面的裂痕。",
    description:
      "大阪的繁华背后，是盘根错节的地下交易。刑警堂本多年追查的旧案有了新线索，他必须深入危险地带，与昔日的对手周旋。影片节奏紧凑，是一部充满张力的犯罪类型片。",
    tags: ["黑帮", "硬汉", "都市", "高能"],
    episodes: 0,
    director: "北野武之",
    cast: ["役所真司", "松重丰田", "安藤樱乃"],
    featured: false,
  },
  {
    id: "our-summer",
    title: "我们的夏天",
    type: "series",
    year: 2024,
    region: "其他",
    genres: ["青春", "爱情"],
    rating: 8.6,
    popularity: 8450,
    cover:
      "https://readdy.ai/api/search-image?query=Youthful%20Japanese%20summer%20drama%20poster%2C%20group%20of%20teenagers%20at%20seaside%20festival%20with%20fireworks%2C%20yukata%20and%20festive%20lights%2C%20warm%20orange%20summer%20evening%2C%20joyful%20bittersweet%20mood%2C%20vivid%20cinematic%20tones&width=400&height=600&seq=mv-cover-12&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Japanese%20summer%20festival%20at%20dusk%2C%20colorful%20lanterns%20and%20food%20stalls%2C%20fireworks%20blooming%20over%20the%20sea%2C%20teenagers%20in%20yukata%2C%20warm%20festive%20glow%2C%20youthful%20nostalgic%20cinematic%20scene&width=1600&height=900&seq=mv-hero-12&orientation=landscape",
    synopsis: "五名高中生的最后一个夏天，友情与初恋在烟火下悄然生长。",
    description:
      "高三那年夏天，五个性格迥异的好友约定要一起看完所有的烟火大会。随着毕业临近，他们各自面对升学的压力与青涩的心事。剧集真实地还原了青春里那些闪闪发光又带着遗憾的日子。",
    tags: ["青春", "校园", "友情", "初恋"],
    episodes: 8,
    director: "福田桃子",
    cast: ["永野芽郁", "山崎天", "北村匠海"],
    featured: true,
  },
  {
    id: "onsen-secret",
    title: "温泉旅馆的秘密",
    type: "series",
    year: 2023,
    region: "其他",
    genres: ["悬疑", "剧情"],
    rating: 8.2,
    popularity: 6320,
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20mystery%20drama%20poster%2C%20traditional%20Japanese%20hot%20spring%20inn%20at%20night%20with%20fog%2C%20stone%20path%20and%20lanterns%2C%20silhouette%20in%20doorway%2C%20dark%20moody%20green%20and%20warm%20amber%2C%20eerie%20elegant%20mood&width=400&height=600&seq=mv-cover-13&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Serene%20Japanese%20hot%20spring%20inn%20surrounded%20by%20mountains%2C%20steaming%20outdoor%20onsen%2C%20stone%20lanterns%2C%20misty%20twilight%2C%20traditional%20wooden%20architecture%2C%20mysterious%20calm%20cinematic%20atmosphere&width=1600&height=900&seq=mv-hero-13&orientation=landscape",
    synopsis: "群山环抱的温泉旅馆里，每个住客都藏着不愿说出口的秘密。",
    description:
      "偏远的温泉旅馆迎来一群看似毫无关联的客人。一场突如其来的大雪让他们被困山中，随之而来的是接连发生的怪事。旅馆女主人与年轻记者一同揭开尘封多年的往事。",
    tags: ["本格推理", "暴风雪山庄", "氛围感"],
    episodes: 9,
    director: "堤幸彦介",
    cast: ["天海祐子", "生田斗真一", "柴崎幸子"],
    featured: false,
  },
  {
    id: "ninja-path",
    title: "忍者之路",
    type: "movie",
    year: 2022,
    region: "其他",
    genres: ["动作", "历史"],
    rating: 7.6,
    popularity: 5410,
    cover:
      "https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20poster%2C%20ninja%20leaping%20across%20moonlit%20rooftops%2C%20flowing%20black%20cloak%2C%20full%20moon%20and%20traditional%20pagoda%2C%20dynamic%20motion%2C%20deep%20red%20and%20ink%20black%20tones%2C%20stylized%20dramatic%20art&width=400&height=600&seq=mv-cover-14&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Moody%20moonlit%20Japanese%20castle%20rooftops%2C%20ninja%20silhouette%20leaping%20across%20tiles%2C%20full%20moon%20in%20dark%20sky%2C%20dramatic%20shadows%2C%20action%20cinematic%20film%20still%2C%20high%20contrast%20ink%20and%20red%20tones&width=1600&height=900&seq=mv-hero-14&orientation=landscape",
    synopsis: "战国乱世，一名年轻的忍者接下不可能完成的任务。",
    description:
      "战国末期，年轻的忍者月丸受命潜入戒备森严的城池，窃取一份关乎天下大势的密函。他必须在敌人的重重围捕中完成任务，同时守护心中最后的信义。影片动作设计凌厉，场面精彩。",
    tags: ["忍者", "动作", "爽片", "战国"],
    episodes: 0,
    director: "下山天野",
    cast: ["山田孝之介", "冈田准一", "仲间由纪"],
    featured: false,
  },
  {
    id: "bento-spring",
    title: "便当店的春天",
    type: "series",
    year: 2024,
    region: "其他",
    genres: ["家庭", "剧情"],
    rating: 8.0,
    popularity: 5680,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20Japanese%20family%20series%20poster%2C%20cheerful%20small%20bento%20shop%20with%20colorful%20lunch%20boxes%2C%20mother%20and%20child%20smiling%2C%20bright%20spring%20daylight%2C%20cozy%20wholesome%20mood%2C%20warm%20soft%20color%20palette&width=400&height=600&seq=mv-cover-15&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Bright%20cheerful%20Japanese%20bento%20shop%20in%20spring%2C%20colorful%20lunch%20boxes%20on%20display%2C%20blossoms%20outside%20window%2C%20warm%20morning%20light%2C%20wholesome%20family%20cinematic%20scene&width=1600&height=900&seq=mv-hero-15&orientation=landscape",
    synopsis: "一家小小的便当店，用一份份午餐连接起街坊邻里的喜怒哀乐。",
    description:
      "单亲妈妈美咲独自经营着一家便当店。每天清晨，她为形形色色的客人准备便当，也见证着他们的人生片段。剧集以温暖细腻的笔触，讲述普通人彼此扶持的日常故事。",
    tags: ["治愈", "美食", "亲情", "烟火气"],
    episodes: 10,
    director: "河濑直美子",
    cast: ["满岛光希", "芦田爱菜", "松坂桃李"],
    featured: false,
  },
  {
    id: "silent-confession",
    title: "无声告白",
    type: "movie",
    year: 2023,
    region: "东京",
    genres: ["悬疑", "爱情"],
    rating: 8.4,
    popularity: 6980,
    cover:
      "https://readdy.ai/api/search-image?query=Stylish%20romantic%20mystery%20poster%2C%20two%20figures%20standing%20apart%20in%20a%20dim%20corridor%2C%20window%20light%20between%20them%2C%20muted%20red%20and%20gray%20tones%2C%20subtle%20tension%2C%20minimal%20elegant%20composition&width=400&height=600&seq=mv-cover-16&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Moody%20minimal%20interior%20scene%2C%20long%20dim%20corridor%20with%20a%20single%20window%20casting%20light%2C%20two%20distant%20figures%2C%20soft%20red%20and%20gray%20palette%2C%20romantic%20mystery%20cinematic%20mood&width=1600&height=900&seq=mv-hero-16&orientation=landscape",
    synopsis: "一封从未寄出的信，牵出了一段被误解了十年的感情。",
    description:
      "整理旧物时，美咲发现了一封从未寄出的信。循着信中的线索，她重新遇见了十年前的那个他，也终于明白了当年沉默背后的心意。影片用交错的时间线，讲述一段关于错过的告白。",
    tags: ["悬疑爱情", "错过", "细腻", "高口碑"],
    episodes: 0,
    director: "岩井俊和",
    cast: ["有村架纯", "佐藤健司"],
    featured: false,
  },
  {
    id: "future-train",
    title: "未来列车",
    type: "series",
    year: 2025,
    region: "东京",
    genres: ["科幻", "悬疑"],
    rating: 8.1,
    popularity: 7760,
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20Japanese%20sci-fi%20drama%20poster%2C%20sleek%20high%20speed%20train%20gliding%20through%20neon%20city%2C%20time%20distortion%20visual%20effect%2C%20cool%20red%20and%20steel%20tones%2C%20high%20tech%20cinematic%20composition&width=400&height=600&seq=mv-cover-17&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Futuristic%20city%20skyline%20with%20a%20sleek%20high%20speed%20train%20passing%2C%20neon%20lights%20and%20motion%20blur%2C%20sci-fi%20atmosphere%2C%20cool%20red%20and%20steel%20blue%20palette%2C%20cinematic%20high%20detail&width=1600&height=900&seq=mv-hero-17&orientation=landscape",
    synopsis: "一列能够穿越时间的列车，载着乘客驶向无法回头的未来。",
    description:
      "不远的未来，科技公司推出了一列神秘的列车，据说可以穿越时间。登车的乘客各怀目的，却逐渐发现旅程远比想象中危险。随着谜团层层揭开，列车背后隐藏的真相令人震惊。",
    tags: ["时间旅行", "烧脑", "高科技", "悬念"],
    episodes: 12,
    director: "细田守仁",
    cast: ["小栗旬一", "长泽雅子", "染谷将太"],
    featured: true,
  },
  {
    id: "hanabi-promise",
    title: "花火之约",
    type: "movie",
    year: 2024,
    region: "其他",
    genres: ["爱情", "青春"],
    rating: 7.8,
    popularity: 5820,
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20summer%20festival%20movie%20poster%2C%20couple%20in%20yukata%20watching%20fireworks%20over%20a%20lake%2C%20reflected%20colorful%20sparks%2C%20warm%20summer%20night%2C%20tender%20bittersweet%20mood%2C%20rich%20vivid%20tones&width=400&height=600&seq=mv-cover-18&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Stunning%20Japanese%20summer%20fireworks%20over%20a%20calm%20lake%2C%20reflections%20on%20water%2C%20two%20figures%20silhouetted%20in%20foreground%2C%20warm%20festive%20glow%2C%20romantic%20cinematic%20scene%2C%20high%20detail&width=1600&height=900&seq=mv-hero-18&orientation=landscape",
    synopsis: "约定一起看花火的两个人，却在那个夏天后走向了不同的方向。",
    description:
      "长野的湖畔小镇，每年夏天都会举办花火大会。少年拓海与青梅竹马遥约定，无论身在何处都要一起回来。多年后，当花火再次绽放，他们是否还能兑现当年的约定？",
    tags: ["青春", "初恋", "约定", "夏日"],
    episodes: 0,
    director: "行定勋平",
    cast: ["福原遥香", "冈田将生", "桥本环奈"],
    featured: false,
  },
  {
    id: "the-chef",
    title: "料理人·四季",
    type: "series",
    year: 2023,
    region: "京都",
    genres: ["剧情", "美食"],
    rating: 8.7,
    popularity: 7340,
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20food%20drama%20poster%2C%20skilled%20chef%20presenting%20artful%20kaiseki%20dish%2C%20traditional%20Kyoto%20kitchen%2C%20steam%20and%20warm%20light%2C%20refined%20minimal%20mood%2C%20warm%20muted%20tones%2C%20beautiful%20food%20photography&width=400&height=600&seq=mv-cover-19&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Traditional%20Japanese%20kaiseki%20kitchen%2C%20chef%20preparing%20an%20elegant%20dish%2C%20warm%20lantern%20light%2C%20fresh%20seasonal%20ingredients%2C%20refined%20culinary%20cinematic%20scene%2C%20warm%20harmonious%20tones&width=1600&height=900&seq=mv-hero-19&orientation=landscape",
    synopsis: "一位年轻料理人回到京都老店，在四季更替中追寻料理的真意。",
    description:
      "料理人修一在海外修行多年后回到京都，接手祖父留下的割烹料理店。为了重现店里的招牌料理，他走遍四季，寻找时令食材。剧集以美食为线索，讲述匠心、传承与自我和解的故事。",
    tags: ["美食", "匠心", "传承", "治愈"],
    episodes: 12,
    director: "山田洋次郎",
    cast: ["木村拓哉", "竹内结子", "松重丰"],
    featured: false,
  },
  {
    id: "midnight-taxi",
    title: "深夜出租车",
    type: "movie",
    year: 2025,
    region: "东京",
    genres: ["剧情", "犯罪"],
    rating: 8.3,
    popularity: 6640,
    cover:
      "https://readdy.ai/api/search-image?query=Neo-noir%20Japanese%20film%20poster%2C%20lone%20taxi%20driving%20through%20empty%20rainy%20city%20streets%20at%20night%2C%20glowing%20tail%20lights%2C%20dark%20red%20and%20black%20tones%2C%20lonely%20cinematic%20mood%2C%20reflective%20wet%20asphalt&width=400&height=600&seq=mv-cover-20&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Lone%20taxi%20driving%20through%20empty%20rainy%20Tokyo%20streets%20at%20night%2C%20glowing%20red%20tail%20lights%20and%20reflections%2C%20moody%20neo-noir%20atmosphere%2C%20cinematic%20wide%20shot%2C%20high%20detail&width=1600&height=900&seq=mv-hero-20&orientation=landscape",
    synopsis: "一名深夜出租车司机，载着形形色色的乘客，也载着他们的秘密。",
    description:
      "东京的深夜，出租车司机诚一载着每一位客人穿过空旷的街道。乘客们或许是逃避追捕的罪犯，或许是思念故人的老人。每一次旅程都是一段人生。影片以独特的视角，描绘都市夜晚的人生百态。",
    tags: ["都市", "群像", "黑色电影", "余韵"],
    episodes: 0,
    director: "园子温之",
    cast: ["浅野忠信", "安藤樱", "窪冢洋介"],
    featured: false,
  },
];

export const regionOptions = ["全部", "东京", "大阪", "京都", "北海道", "其他"];

export const yearOptions = ["全部", "2025", "2024", "2023", "2022"];

export const genreOptions = [
  "全部",
  "剧情",
  "爱情",
  "悬疑",
  "犯罪",
  "动画",
  "科幻",
  "历史",
  "家庭",
  "青春",
  "动作",
  "美食",
];

export const categoryMeta: Record<
  "movie" | "series",
  { name: string; title: string; desc: string; intro: string }
> = {
  movie: {
    name: "电影",
    title: "电影 - 日本在线观看",
    desc: "浏览最新最全的日本电影资源，涵盖悬疑、爱情、动画、动作等热门类型。",
    intro: "精选日本院线电影与经典佳作，从悬疑推理到治愈爱情，满足你的观影需求。",
  },
  series: {
    name: "电视剧",
    title: "电视剧 - 日本在线观看",
    desc: "浏览最新最全的日本电视剧资源，热门日剧、口碑佳作一网打尽。",
    intro: "汇集当下热播与口碑日剧，从都市悬疑到治愈家庭，追剧不再迷路。",
  },
};